import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/all.js'
import router from '@/router'
// import Queue from './queue.js'
// import Charge from './charge.js'
Vue.use(Vuex)
const store = new Vuex.Store({
  // modules: {
  //   queue: Queue,
  //   charge: Charge,
  // },

  // 1. state
  state: {
    balance: 0,
    orderstatusVisible: false,
    orderFinishVisible: false,
    selectServerRoomVisible: false,
    // selectServerRoomVisible: true,
    hasOrder: false,
    orderCheckTime: 0,
    user: JSON.parse(sessionStorage.getItem(`user`)) || null,
    product: null,
    graphicsCards: null,
    serverRoomId: null,
    updateDialogVisible: true,
    order: null,
    token: null,
    fpsChangeStatus: false, // pkview 切换fps状态
    activityData: {
      img: '',
      show: false,
      jumpUrl: '',
    },
    webVersion: '',
    isRunningSpeedTest: false, // 是否运行测速
    // isRunningSpeedTest: true, // 是否运行测速
    isRegister: -1,
    backTop: true
  },

  // // 2. getters
  getters: {
    // 参数列表state指的是state数据
    getBalanceFn(state) {
      return state.balance
    },
    graphicsCards(state) {
      return state.graphicsCards
    },
    product(state) {
      return state.product
    },
    activityData(state) {
      return state.activityData
    },
    user(state) {
      return state.user
    },
    order(state) {
      return state.order
    },
    webVersion(state) {
      return state.webVersion
    },
    serverRoomId(state) {
      return state.serverRoomId
    },
    hasGuide(state) {
      return state.hasGuide
    },
    isRunningSpeedTest(state) {
      return state.isRunningSpeedTest
    },
    stopServerTime(state) {
      return state.stopServerTime
    },
    orderCheckTime(state) {
      return state.orderCheckTime
    },
    updateDialogVisible(state) {
      return state.updateDialogVisible
    },
    onPkView(state) {
      return state.onPkView
    },
    hasOrder(state) {
      return state.hasOrder
    },
    isStandby(state) {
      return state.isStandby
    },
    queueStatus(state) {
      return state.queueStatus
    },
    isRegister(state) {
      return state.isRegister
    },
    backTop(state) {
      return state.backTop
    },
  },
  actions: {
    setBalance({ commit, state }, balance) {
      commit('setBalance', balance)
    },
    
    // 查看是否注册
    checkRegister({ commit, state }, mobile){
      // api.validate_mobile({mobile: mobile}).then(res =>{
      //   console.log(res)
      //   // 
      // })
      // const res =  this.$http.validate_mobile({mobile: this.form2.mobile}).then(res =>{
      //   //     // console.log(res)
      //   //     this.$store.dispatch('checkRegister',res.data.isRegister);
      //   //     // commit('setAgree', res.data);
      //     })
      commit('setAgree', mobile);
    },
    handleLoginSuccess({ commit, state }, data) {

      // 写入本地缓存中
      localStorage.setItem('user', JSON.stringify(data.customer))
      commit('setToken', data.Authorization)
      localStorage.setItem('token', data.Authorization)
      // 写入vuex中，方便跳转数据处理
      commit('setUser', data.customer)
      // 防挂机设置
      if(data.special){
        router.push('/user')
      }else{
        router.push('/')
      }
    },
    getMyInfo({ commit, state }) { 
      api.get_my_info().then(res => {
        // 写入本地缓存中
        localStorage.setItem('user', JSON.stringify(res.data.customer))
        localStorage.setItem('token', res.data.token)
        commit('setUser', res.data.customer)
      })
    },
    logout({ commit, dispatch }) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      commit('setUser', null)
      commit('setOrder', null)
      commit('setHasOrder', false)
      // store.dispatch('switchServerRoom', null)
      router.push({ path: '/mobile' })
      api.logoutApi(null).then(res => {
        console.log(2322)
      })
      router.push({ path: '/mobile' })
    },
    /* switchServerRoom({ commit, state }, serverRoomId) {
      commit('setServerRoomId', serverRoomId)
      // 设置默认机房
      if( this.state.user){
        if (serverRoomId !== this.state.user.serverRoomId) {
          api.set_server_room({ serverRoomId }).then(res => {
            localStorage.setItem('user', JSON.stringify(res.data))
            commit('setUser', res.data);
          })
        }
      }
      
    },
    // 结束订单
    finishOrder({ state, commit }) {
      let { orderId } = state.order
      if (orderId) {
        window.logoutNode(orderId)
      }
    }, */
  },
  mutations: {
    setAgree(state, agree){
      state.isRegister = agree
    },
    setNickname(state, nickname) {
      state.nickname = nickname // 将传参设置给state的nickname
    },
    setAvatar(state, avatar) {
      state.avatar = avatar // 将传参设置给state的avatar
    },
    setBalance(state, balance) {
      state.user.balance = balance
    },
    setCustomerType(state, customerType) {
      state.user.customerType = customerType
    },
    setOrderstatusVisible(state, orderstatusVisible) {
      state.orderstatusVisible = orderstatusVisible
    },
    setOrderFinishVisible(state, orderFinishVisible) {
      state.orderFinishVisible = orderFinishVisible
    },
    setSelectServerRoomVisible(state, selectServerRoomVisible) {
      state.selectServerRoomVisible = selectServerRoomVisible
    },
    setOrder(state, order) {
      state.order = order
    },
    setWebVersion(state, webVersion) {
      state.webVersion = webVersion
    },
    setOrderCheck(state, orderCheckTime) {
      state.orderCheckTime = orderCheckTime
    },
    setFpsChangeStatus(state, fpsChangeStatus) {
      state.fpsChangeStatus = fpsChangeStatus
    },
    setToken(state, token) {
      state.token = token
    },
    setUser(state, user) {
      state.user = user
    },
    setProduct(state, product) {
      state.product = product
    },
    setGraphicsCards(state, graphicsCards) {
      state.graphicsCards = graphicsCards
    },
    setHasOrder(state, hasOrder) {
      state.hasOrder = hasOrder
    },
    setServerRoomId(state, serverRoomId) {
      state.serverRoomId = serverRoomId
    },
    setActivityData(state, activityData) {
      state.activityData = activityData
    },
    setIsRunningSpeedTest(state, isRunningSpeedTest) {
      state.isRunningSpeedTest = isRunningSpeedTest
    },
    setStopServerTime(state, stopServerTime) {
      state.stopServerTime = stopServerTime
    },
    setHasGuide(state, hasGuide) {
      window.localStorage.setItem('user-guide', hasGuide)
      state.hasGuide = hasGuide
    },
    setOnPkView(state, onPkView) {
      window.localStorage.setItem('onPkView', onPkView)
      state.onPkView = onPkView
    },
    setIsStandby(state, isStandby) {
      window.localStorage.setItem('isStandby', isStandby)
      state.isStandby = isStandby
    },
    setUpdateDialogVisible(state, updateDialogVisible) {
      state.updateDialogVisible = updateDialogVisible
    },
    setBackTop(state,status){
      state.backTop = status
    },
  },
})
export default store
